export default __webpack_public_path__ + "2f8c2d6eec5a05bd1e1c976153270a4b.svg";